import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import './News.css';

function NewsDetail() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const n = t.news;

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    async function fetchArticle() {
      try {
        const res = await fetch(`/api/news/${uuid}`);
        if (res.status === 404) {
          setNotFound(true);
          return;
        }
        const data = await res.json();
        setArticle(data);
      } finally {
        setLoading(false);
      }
    }
    fetchArticle();
  }, [uuid]);

  return (
    <div className="news-page">
      <div className="page-header">
        <div className="container">
          {!loading && !notFound && article && (
            <Helmet>
              <title>{article.title} - 首嘉/深圳瀚阳</title>
              <meta
                name="description"
                content={article.summary || '首嘉/深圳瀚阳新闻详情'}
              />
              <meta
                property="og:title"
                content={`${article.title} - 首嘉/深圳瀚阳`}
              />
              <meta property="og:description" content={article.summary || ''} />
              <meta
                property="og:url"
                content={`https://www.sz-showjoy.com/news/${uuid}`}
              />
              <meta name="keywords" content={`${article.title},物流新闻,首嘉/深圳瀚阳,行业资讯`} />
              <link
                rel="canonical"
                href={`https://www.sz-showjoy.com/news/${uuid}`}
              />
            </Helmet>
          )}
          {loading ? (
            <>
              <h1>{n.pageTitle}</h1>
              <p>{n.loading}</p>
            </>
          ) : notFound || !article ? (
            <>
              <h1>{n.pageTitle}</h1>
              <p>{n.notFound}</p>
            </>
          ) : (
            <>
              <div className="news-detail-header-category">
                {n.categories?.[article.category] || article.category}
              </div>
              <h1 className="news-detail-header-title">{article.title}</h1>
              <p className="news-detail-header-date">
                {new Date(article.created_at).toLocaleDateString('zh-CN', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </>
          )}
        </div>
      </div>

      <section className="section">
        <div className="container">
          <button className="news-back-btn" onClick={() => navigate('/news')}>
            ← {n.backToList}
          </button>

          {loading ? (
            <p
              style={{
                color: '#6b7280',
                textAlign: 'center',
                padding: '60px 0',
              }}
            >
              {n.loading}
            </p>
          ) : notFound || !article ? (
            <p
              style={{
                color: '#6b7280',
                textAlign: 'center',
                padding: '60px 0',
              }}
            >
              {n.notFound}
            </p>
          ) : (
            <article className="news-detail-body">
              <p className="news-detail-summary">{article.summary}</p>
              {article.content && (
                <div
                  className="news-detail-content ql-editor"
                  dangerouslySetInnerHTML={{ __html: article.content }}
                />
              )}
            </article>
          )}
        </div>
      </section>
    </div>
  );
}

export default NewsDetail;
